import React from 'react';
import Script from 'next/script';

const ArchiProSnippet = () => {
  return (
    <>
      <Script id="archipro-pixel-init" strategy="afterInteractive">
        {`
        window.ApData = window.ApData || [];
        function apa(){
            window.ApData.push(arguments);
        }
        apa('id','methven');
        `}
      </Script>
      <Script id="archipro-pixel" src="https://pixel.archipro.co.nz/ap-analytics.js" strategy="afterInteractive" />
    </>
  );
};

export default ArchiProSnippet;
